import React from 'react';
import { DetailSectionModularProps, mapDispatchToProps, mapStateToProps } from 'component/page/detail/DetailCard/DetailsCard.selectors';
import { Box } from '@drone-js/core';
import { connect } from 'react-redux';
import {
    BookingCounterNodeComponent,
    HighlightBadgesNodeComponent,
    ReviewSummaryNodeComponent,
    SectionTitleComponent,
} from 'component/page/detail/DetailCard/DetailTitleSectionComponents';

const DetailTitleNoThumbnail: React.FC<DetailSectionModularProps> = (props) => {
    return (
        <Box data-testid="details-card">
            <HighlightBadgesNodeComponent badges={props.badges} activityId={props.activityId} isPageContainerSpacing={props.pageContainerSpacing} />
            <SectionTitleComponent isPageContainerSpacing={props.pageContainerSpacing} contentLocale={props.contentLocale} title={props.title} />
            <Box display="flex" flexDirection="row" alignItems="center" my="8">
                <ReviewSummaryNodeComponent
                    reviewTotalReview={props.reviewTotalReview}
                    reviewAverageScore={props.reviewAverageScore}
                    cms={props.cms}
                    contentLocale={props.contentLocale}
                    onSeeReviewClick={props.onSeeReviewClick}
                    variant={props.variant}
                />
                <BookingCounterNodeComponent badges={props.badges} reviewAverageScore={props.reviewAverageScore} reviewTotalReview={props.reviewTotalReview} />
            </Box>
        </Box>
    );
};

DetailTitleNoThumbnail.displayName = 'DetailTitleNoThumbnail';

export default connect(mapStateToProps, mapDispatchToProps)(DetailTitleNoThumbnail);
